import type { ReactNode } from 'react';

/** A padded group of `UserMenuItem`s. */
export function UserMenuSection({ children }: { children: ReactNode }) {
  return <div className='py-1 px-1'>{children}</div>;
}
